import * as React from 'react';
import { inject } from 'mobx-react';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { SrpTemplate } from 'src/common/stores/page-layout/page-layout-store-utils';
import { packageTypeMap } from 'stores/adapters';
import { MitSearchFormWrapper } from 'components/multi-item/multi-item-search-form-wrapper';
import usePrebundle from 'utils/prebundle-hook-util';
import useIsSearchFormDisabled from 'utils/searchFormDisabled-hook-util';
import { SharedUiUniversalSearchFormWrapper } from '../../common/universal-search-form/universal-search-form-wrapper';
export const Playback = inject('multiItem', 'pageLayout')(({
  multiItem,
  pageLayout
}) => {
  const isPrebundle = usePrebundle() === 'true';
  const isSearchFormDisabled = useIsSearchFormDisabled() === 'true';
  if (isPrebundle || isSearchFormDisabled) {
    return null;
  }
  const isPageMultiItem = multiItem === null || multiItem === void 0 ? void 0 : multiItem.isPackageShoppingPath();
  const packageTypeDomain = multiItem === null || multiItem === void 0 ? void 0 : multiItem.getPackageType();
  const packageType = packageTypeDomain === null || packageTypeDomain === undefined ? undefined : packageTypeMap[packageTypeDomain];
  const isSplitView = (pageLayout === null || pageLayout === void 0 ? void 0 : pageLayout.templateName) === SrpTemplate.SplitView;
  const spacingProps = isSplitView ? {
    margin: {
      small: {
        inline: 'three',
        blockstart: 'three'
      },
      medium: {
        inline: 'six',
        blockstart: 'four'
      },
      large: {
        inline: 'six',
        blockstart: 'four'
      }
    }
  } : {
    margin: {
      small: {
        inline: 'three',
        blockstart: 'three'
      },
      medium: {
        inline: 'unset',
        blockstart: 'six',
        blockend: 'two'
      },
      large: {
        blockend: 'one'
      }
    }
  };
  return React.createElement(EGDSSpacing, Object.assign({}, spacingProps), React.createElement("div", null, isPageMultiItem ? React.createElement(MitSearchFormWrapper, {
    packageType: packageType
  }) : React.createElement(SharedUiUniversalSearchFormWrapper, null)));
});